export class ObjectUtils {
    constructor() {

    }


    static objectToMap(object: { [key: string]: string }): Map<string, string> {
        return new Map(Object.entries(object));
    }

    static objectToArray(object: { [key: string]: any }): Array<{ key: string, value: any }> {
        return Object.entries(object).map(m => {
            return { key: m[0], value: m[1] }
        });
    }

    private static varExtractor = new RegExp("return (.*);");
    static getVariableName<TResult>(name: () => TResult) {
        var m = ObjectUtils.varExtractor.exec(name + "");
        if (m == null) throw new Error("The function does not contain a statement matching 'return variableName;'");
        return m[1];
    }

    static isJson(str: string) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }


    static objectsEqual(o1: any, o2: any): boolean {
        return o1 && o2 && typeof o1 === 'object' && Object.keys(o1).length > 0
            ? Object.keys(o1).length === Object.keys(o2).length
            && Object.keys(o1).every(p => ObjectUtils.objectsEqual(o1[p], o2[p]))
            : o1 === o2;
    }

    static arraysEqual(a1: any[], a2: any[]): boolean {
        return a1.length === a2.length && a1.every((o, idx) => ObjectUtils.objectsEqual(o, a2[idx]));
    }
}